import gql from "graphql-tag";

const GET_OFFERS = gql`
  query getOffers {
    getOffers {
      _id
      user {
        _id
        username
        fullName
        company
      }
      orderNumber
      cart {
        product {
          name
        }
        totalPrice
        surface
        quantity
        price
        dimension {
          sheetWidth
          sheetHeight
        }
      }
      priceToPay {
        withoutTax
        withTax
      }
      dateCreated
      sentToBuyer {
        date
        status
      }
      approvedByAdministrator {
        date
        status
      }
      createdByGuest {
        status
        contactInfo {
          fullName
          phoneNumber
        }
      }
      note
      sentToInvoicing {
        status
        date
      }
      sentToWarehouse {
        status
        date
      }
    }
  }
`;

export default GET_OFFERS;
